import { useMemo } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import type { ApiToken } from "src/queries/auth/tokens.types";
import type { TokenMenuAnchor } from "../../SystemSettingsTokenManagement.types";
import SystemSettingsTokenManagementRowMenu from "../SystemSettingsTokenManagementRowMenu/SystemSettingsTokenManagementRowMenu";
import { getTokenManagementColumns } from "./SystemSettingsTokenManagementTable.columns";

interface SystemSettingsTokenManagementTableProps {
  displayedTokens: ApiToken[];
  menuAnchor: TokenMenuAnchor | null;
  onOpenMenu: (el: HTMLElement, token: ApiToken) => void;
  onMenuClose: () => void;
  onRevoke: (token: ApiToken) => void;
  onReactivate: (token: ApiToken) => void;
  onDelete: (token: ApiToken) => void;
}

export default function SystemSettingsTokenManagementTable({
  displayedTokens,
  menuAnchor,
  onOpenMenu,
  onMenuClose,
  onRevoke,
  onReactivate,
  onDelete,
}: SystemSettingsTokenManagementTableProps) {
  const columns = useMemo(() => getTokenManagementColumns(onOpenMenu), [onOpenMenu]);

  return (
    <>
      <div className="overflow-x-auto">
        <DataGridPro<ApiToken>
          rows={displayedTokens}
          columns={columns}
          getRowId={(row) => row.jti}
          density="compact"
          disableRowSelectionOnClick
          disableColumnMenu
          hideFooter
          autoHeight
          sx={{
            // hide the scrollbar because an ancestor wrapper can be transition from small with to wide width which should be enough for this table
            ".MuiDataGrid-scrollbar": {
              display: "none",
            },
          }}
        />
      </div>
      <SystemSettingsTokenManagementRowMenu
        menuAnchor={menuAnchor}
        onClose={onMenuClose}
        onRevoke={onRevoke}
        onReactivate={onReactivate}
        onDelete={onDelete}
      />
    </>
  );
}
